// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Radio-module__wrapper","customRaduis":"Radio-module__customRaduis"};